import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { getSiteUrl, copyToClipboard } from "../../utils/GeneralUtils";

import styles from "./sharesns.module.scss";

type Props = {
  isPreview?: boolean;
};
const ShareSNS: React.FC<Props> = ({ isPreview = false }) => {
  const [isCopied, setIsCopied] = useState<boolean>(false);

  const copyUrl = () => {
    copyToClipboard();
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 3000);
  };

  //現在のurlを取得
  const url = getSiteUrl().slice(0, -1) + useLocation().pathname;

  return (
    <>
      <ul className={styles["share-sns"]}>
        <li className={`${styles["share-sns_item"]} ${styles["twitter"]}`}>
          {isPreview ? (
            <a>
              <FontAwesomeIcon icon={["fab", "x-twitter"]} />X でシェア
            </a>
          ) : (
            <a
              href={`https://twitter.com/intent/tweet?url=${url}`}
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={["fab", "x-twitter"]} />X でシェア
            </a>
          )}
        </li>
        <li className={`${styles["share-sns_item"]} ${styles["line"]}`}>
          {isPreview ? (
            <a>
              <FontAwesomeIcon icon={["fab", "line"]} />
              LINEでシェア
            </a>
          ) : (
            <a
              href={`https://social-plugins.line.me/lineit/share?url=${url}`}
              rel="nofollow noopener noreferrer"
              target="_blank"
            >
              <FontAwesomeIcon icon={["fab", "line"]} />
              LINEでシェア
            </a>
          )}
        </li>
        <li className={`${styles["share-sns_item"]} ${styles["copy"]}`}>
          <button
            type="button"
            onClick={isPreview ? () => {} : () => copyUrl()}
          >
            URLをコピー
          </button>
          <div
            className={`${styles["share-sns_item__modal"]} ${
              isCopied ? styles["show"] : ""
            }`}
          >
            <p>コピーしました</p>
          </div>
        </li>
      </ul>
    </>
  );
};

export default ShareSNS;
